import React, { Component } from 'react';

import ScrollableAnchor from 'react-scrollable-anchor';
import { configureAnchors } from 'react-scrollable-anchor';

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
 
import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';

import Media from 'react-media';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import faHome from '@fortawesome/fontawesome-free-solid/faHome';
import faBars from '@fortawesome/fontawesome-free-solid/faBars';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
// import faUsers from '@fortawesome/fontawesome-free-solid/faUsers';
import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import faCaretUp from '@fortawesome/fontawesome-free-solid/faCaretUp';
import faLongArrowAltUp from '@fortawesome/fontawesome-free-solid/faLongArrowAltUp';
import faLongArrowAltDown from '@fortawesome/fontawesome-free-solid/faLongArrowAltDown';

import clFlag from './icons/cl.png';
import gbFlag from './icons/gb.png';

import './App.css';

// import photo from './images/Pusaki3.jpg';

import {accomodationDetailsEn} from './data/data.js';
import {accomodationDetailsEs} from './data/data.js'; 

import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

// Offset all anchors by -60 to account for a fixed header
// and scroll more quickly than the default 400ms
configureAnchors({offset: -115, scrollDuration: 200})

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={props.mapCenter}
  >
    {props.markers.map(marker => (
      <Marker
        position={{ lat: marker.markerLat, lng: marker.markerLon }}
        title={marker.markerText}
        key={marker.markerId}
      />
    ))}
  </GoogleMap>
))

class MenuItem extends Component {
  
  click = () => {
    this.props.onItemClick();
  }
  render () {
    const href=this.props.href;
    const title=this.props.title;
    return (
      <li><a href={href} onClick={this.click}>{title}</a></li>
    )
  }
}

class Menu extends Component {

  onItemClick = () => {
    this.props.onItemClick();
  }

  onLangClick = () => {
    this.props.onLangClick();
  }

  render () {
    const menuItems = this.props.menuItems;
    const itemsOn = this.props.itemsOn;
    const isEnglish = this.props.isEnglish;

    return (
      <Media query="(max-width: 960px)">
        {matches =>
          matches ? (
            <nav style={{display: itemsOn ? 'block' : 'none' }}>
              <ul>
                {menuItems.map((menuItem) => 
                  <MenuItem key={menuItem.id}
                    title={menuItem.title}
                    href={menuItem.href}
                    onItemClick={this.onItemClick}
                  />
                )}
                <li className="languageIcon" onClick={this.onLangClick}>
                <img src={isEnglish ? clFlag : gbFlag} alt={isEnglish ? 'Español' : 'English'}/>
                </li>
              </ul>
            </nav>
          ) : (
            <nav style={{display: 'block' }}>
              <ul>
                {menuItems.map((menuItem) => 
                  <MenuItem key={menuItem.id}
                    title={menuItem.title}
                    href={menuItem.href}
                    onItemClick={this.onItemClick}
                  />
                )}
                <li className="languageIcon" onClick={this.onLangClick}>
                  <img src={isEnglish ? clFlag : gbFlag} alt={isEnglish ? 'Español' : 'English'}/>
                </li>
              </ul>
            </nav>
          )
        }
      </Media>
    );
  }
}

class MenuBar extends Component {

  click = () => {
    this.props.onItemsVisibilityChange();
  }

  render() {
    const pageTitle=this.props.pageTitle;
    const itemsOn = this.props.itemsOn;
    const rotation = itemsOn ? 90 : 0;

    return (
      <div className="menu-bar">
        <h1><a href="#home"><FontAwesomeIcon icon={faHome} className="headerIcon" size="1x"/>{pageTitle}</a></h1>
        <Media
          query="(max-width: 960px)"
          render={() => 
            <div className="menu-bars-icon" onClick={this.click}><FontAwesomeIcon icon={faBars} className="menuIcon" size="2x" rotation={rotation}/></div>
          }
        />
      </div>
    );
  }
}

class MenuHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsOn: false
    }
  }

  onLangClick = () => {
    this.props.onLangClick();
  }

  handleToggleMenu = () => {
    this.setState(prevState => ({
      itemsOn: !prevState.itemsOn
    }));
  }

  handleItemClick = () => {
    this.setState({
      itemsOn: false
    })
  }

  render() {
    const itemsOn = this.state.itemsOn;
    const menuItems = this.props.basicProps.menuItems;
    const pageTitle = this.props.basicProps.pageTitle;
    const isEnglish = this.props.isEnglish;

    return (
      <StickyHeader header={
          <div className='mainHeader'>
            <MenuBar itemsOn={itemsOn}
              pageTitle={pageTitle}
              onItemsVisibilityChange={this.handleToggleMenu}
            />
            <Menu menuItems={menuItems}
              itemsOn={itemsOn}
              onItemClick={this.handleItemClick}
              isEnglish={isEnglish}
              onLangClick={this.onLangClick}
            />
          </div>
        }
      />
    );
  }
}

function ImageSliderItem(props) {
  return (
    <img src={props.sliderPhotoURI} className="App-header-image" alt={props.sliderPhotoName} />
  );
}

function ImageSlider(props) {
  const sliderPhotos = props.sliderPhotos;
  return (
    <div className="image-slider">
      {sliderPhotos.map((sliderPhoto) => 
        <ImageSliderItem key={sliderPhoto.sliderPhotoId}
          sliderPhotoURI={sliderPhoto.sliderPhotoURI}
          sliderPhotoName={sliderPhoto.sliderPhotoName}
        />
      )}
    </div>
  );
}

function HighlightsItem(props) {
  const className = 'section ' + props.className;
  return (
    <div className={className}>
      <div className="highlight-icon awesome-icon"><FontAwesomeIcon icon={props.faicon} size={props.iconSize} /></div>
      <div className="highlight-text">{props.value}</div>
    </div>
  );
}

function Highlights(props) {
  const highlights = props.highlights;
  return (
    <div className="highlights-boxes">
      {highlights.map((highlight) => 
        <HighlightsItem key={highlight.key}
          className = {highlight.key}
          value={highlight.value}
          faicon={highlight.faicon}
          iconSize={highlight.iconSize}
        />
      )}
    </div>
  );
}

function BriefDesc(props) {
  const briefDesc = props.briefDesc;
  return (
    <div className="section brief-desc">
      <p><em>{briefDesc}</em></p>
    </div>
  );
}

class ImageCarousel extends Component {
  render() {
    const images = this.props.photos;
 
    return (
      <ImageGallery items={images} />
    );
  }
 
}

class AccItemShort extends Component {
  rowClick = () => {
    this.props.onItemToggle();
  }

  render() {
    const expanded=this.props.expanded;
    const accDetail=this.props.accDetail;
    return(
      <div className="acc-item-short" onClick={this.rowClick}>
        <div className="acc-item-icon awesome-icon"><FontAwesomeIcon icon={faUser} size="1x" /><FontAwesomeIcon icon={faUser} size="1x" /></div>
        <div className="acc-item-name">{accDetail.accItemName}</div>
        <div className="acc-item-price-low"><FontAwesomeIcon icon={faLongArrowAltDown} size="1x"  className="acc-item-price-low-icon" />{accDetail.accItemPriceLow}</div>
        <div className="acc-item-price-high"><FontAwesomeIcon icon={faLongArrowAltUp} size="1x"  className="acc-item-price-high-icon" />{accDetail.accItemPriceHigh}</div>
        <div className="acc-item-plus awesome-icon"><FontAwesomeIcon icon={expanded ? faCaretUp : faCaretDown} size="1x" /></div>
      </div>
    );
  }
    
}

function Acc360(props) {
  const photoUrl = props.photoUrl;
  const photoName = props.photoName;
  return(
    <a className="link360" href={photoUrl} target="_blank">{photoName}</a>
  );
}

function Acc360PhotosText(props) {
  const photos360 = props.photos360;
  const text360 = props.text360;
  return(
    <p>
      {text360}
      {photos360.map((photo360) => 
        <Acc360 key={photo360.photoId}
          photoUrl={photo360.url}
          photoName={photo360.photoName}
        />
      )}
    </p>
  );
}

function AccItemLong(props) {
  const accDetail=props.accDetail;
  const expanded=props.expanded;
  return(
    <div className="acc-item-long" style={{display: expanded ? 'block' : 'none'}}>
      <div className="acc-item-desc">
        <p>{accDetail.accItemDesc}</p>
        <Acc360PhotosText text360={accDetail.accItem360Text} photos360={accDetail.accItem360} />
      </div>
      <div className="acc-item-photos">
        <ImageCarousel photos={accDetail.accItemPhotos}/>
      </div>
    </div>
  );
}

class AccDetailsItem extends Component {
  constructor(props) {
    super(props);
    this.state={
      expanded: false
    }
  }

  handleItemToggle = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  }
  
  render () {
    const accDetail = this.props.accDetail;
    const expanded = this.state.expanded;
    const className = expanded ? "acc-item caretUp" : "acc-item caretDown";
    
    return (
      <div className={className}>
        <AccItemShort
          accDetail={accDetail} 
          expanded={expanded}
          onItemToggle={this.handleItemToggle}
        />
        <AccItemLong
          accDetail={accDetail}
          expanded={expanded}
        />
      </div>
    );
  }
}

function AccDetails(props) {
  const accDetails = props.accDetails;
  return (
    <div className="acc-list">
      {accDetails.map((accDetail) => 
        <AccDetailsItem key={accDetail.accItemId}
          accDetail={accDetail}
        />
      )}
    </div>
  );
}

function ContactDetailsItem(props) {
  const mailto = 'mailto:' + props.value;
  const label = props.label;
  const isMail = label === 'E-mail';
  const contentMail = <a href={mailto}>{props.value}</a>;
  const contentPay = <span>{props.value}<a href="http://www.transferwise.com/u/pavele" target="_blank" rel="noopener noreferrer">Transferwise</a>.</span>;
  const content = isMail ? contentMail : contentPay;
  return (
    <div className="contact-item">
      <div className="contact-item-label">
        <FontAwesomeIcon className='contact-icon' icon={props.faicon} size="1x" />
        {props.label}: 
    </div>
      <div className="contact-item-text">{content}</div>
    </div>
  );
}

function ContactDetails(props) {
  const cDetails = props.mainProps.cDetails;
  const markers = props.mainProps.header.markers;
  const mapCenter = props.mainProps.header.mapCenter;

  return (
    <div className="contacts">
      {cDetails.map((cDetail) => 
        <ContactDetailsItem key={cDetail.label}
          label={cDetail.label}
          faicon={cDetail.faicon}
          value={cDetail.value}
        />
      )}
      <div className="contact-map">
        <MyMapComponent 
          isMarkerShown
          // googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAUvPi4JGx4eq-qt8Gm8PpuYlgtmbwK3gw&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />} 
          markers={markers}
          mapCenter={mapCenter}
        />
      </div>
    </div>
  );
}

function ContactFormHeader(props) {
  const mainProps = props.mainProps;
  const cFormDetails = mainProps.cFormDetails;
  return (
    <header className='visitor-form-header'>
      <h2>{mainProps.headings.h3}</h2>
      <p><em>{cFormDetails.text}</em></p>
      {/* <div className='form-collapse'><FontAwesomeIcon icon={faCaretDown} size="2x" /></div> */}
    </header>
  );
}

class ContactFormBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      email: '',
      message: ''
    };

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const params = 'cEmail='+this.state.email+'&cName='+this.state.fullName+'&cMessage='+this.state.message;
    const resMessage = this.props.mainProps.cFormDetails.responseMessage;
    fetch('http://deptoslaserenafull.cl/php/sendMail.php', {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Accept': 'form-data',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params
    }).then(results => {
      alert(resMessage);
    });
    
  }

  render() {
    const cFormDetails = this.props.mainProps.cFormDetails;
    return (
      <form className='visitor-form' onSubmit={this.handleSubmit}>
        <div className='form-row'>
          <label htmlFor='fullName'>{cFormDetails.nameLabel}</label>
          <input id='fullName' 
            name='fullName' 
            type='text' 
            value={this.state.fullName} 
            onChange={this.handleChange} 
          />
        </div>
        <div className='form-row'>
          <label htmlFor='email'>{cFormDetails.emailLabel}</label>
          <input id='email' 
            name='email' 
            type='email' 
            placeholder='myName@email.com' 
            onChange={this.handleChange} 
          />
        </div>
        <div className='form-row'>
          <label htmlFor='message'>{cFormDetails.messageLabel}</label>
          <textarea id='message'
            name='message' 
            value={this.state.message} 
            onChange={this.handleChange} 
          />
          <div className='instructions'>{cFormDetails.messageHint}</div>
        </div>
        <div className='form-row'>
          <input type="submit" value={cFormDetails.submit} />
        </div>
      </form>
    );
  }
}

function ContactForm(props) {
  const mainProps = props.mainProps;

  return (
    <div className="contact-form">
      <ContactFormHeader
        mainProps={mainProps}
      />
      <ContactFormBody
        mainProps={mainProps}
      />
    </div>
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEnglish: true
    }
  }

  handleChangeLang = () => {
    this.setState(prevState => ({
      isEnglish: !prevState.isEnglish
    }));
  }

  render() {
    const isEnglish = this.state.isEnglish;
    const mainProps = isEnglish ? accomodationDetailsEn : accomodationDetailsEs
    return (
      <div className="App">
        <ScrollableAnchor id={'home'}>
          <MenuHeader
            basicProps={mainProps.header} 
            isEnglish={isEnglish} 
            onLangClick={this.handleChangeLang}
          />
        </ScrollableAnchor>
        <div role="main" className="page"> 
          <div className="section section-img-slider">
            <ImageSlider sliderPhotos={mainProps.header.sliderPhotos} />
          </div>
          <ScrollableAnchor id={'highlight'}>
            <div className="section-highlights">
              <Highlights highlights={mainProps.highlights.highlightBoxes} />
              <BriefDesc briefDesc={mainProps.highlights.briefDesc} />
            </div>
          </ScrollableAnchor>
          <div className="section section-description">
            <ScrollableAnchor id={'accommodation'}>
              <h2>{mainProps.headings.h1}</h2>
            </ScrollableAnchor>
            <AccDetails accDetails={mainProps.accDetails} />
          </div>
          <div className="section section-contacts">
            <ScrollableAnchor id={'contact'}>
              <h2>{mainProps.headings.h2}</h2>
            </ScrollableAnchor>
            <ContactDetails mainProps={mainProps} />
            <ContactForm mainProps={mainProps} />
          </div>
        </div>
        <footer>
          {/* <div className="designed-by"></div> */}
          {/* <div className="transferwise">{mainProps.footer.transferwise}<a href="https://transferwise.com/u/pavele">Transferwise</a></div> */}
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js